export default "__VITE_ASSET__BqsO_BQd__"